<template>
  <div>
    <v-calendar
      class="custom-calendar mw-100"
      is-expanded
      :masks="masks"
      :attributes="availableDates"
      disable-page-swipe
    >
      <div
        slot="day-content"
        slot-scope="{ day, attributes }"
        class="d-flex flex-column h-100 z-10 overflow-auto"
      >
        <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
        <div class="flex-grow-1 overflow-none">
          <div
            v-for="attr in attributes"
            :key="attr.key"
            style="max-width: 140px; cursor: pointer"
            class="small rounded-sm p-1 mt-0 mb-1 overflow-auto"
            :class="attr.customData.class"
            @click="showBookings(attr)"
          >
            <span style="white-space: nowrap" v-html="attr.customData.title"></span>
          </div>
        </div>
      </div>
    </v-calendar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
    };
  },
  computed: {
    ...mapGetters({
      dates: 'bookings/availableDates',
      availableDates: 'bookings/calendarDates',
      availableDatesByDate: 'bookings/availableDatesByDate',
    }),
  },
  methods: {
    ...mapActions({
      getAvailableDates: 'bookings/getAvailableDates',
    }),
    showBookings(date) {
      this.$emit('show-bookings', date);
    },
  },
};
</script>

<style scoped>
.overflow-auto::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
